import TextField from "../../../components/fields/textField/TextField.vue";
import SelectField from "../../../components/fields/selectField/SelectField.vue";
import PeriodoField from "../../../components/fields/periodoField/PeriodoField.vue";
import { HistoricoFeriasService } from "../../../services/HistoricoFeriasService";
import moment from "moment";
export default {
  name: "HistoricoFeriasAnuais",

  components: {
    TextField,
    SelectField,
    PeriodoField
  },

  data: () => ({
    headers: [
      { text: "Ano Referencia", value: "ano_referencia", sortable: false },
      { text: "Data Inicio Férias", value: "data_ini", sortable: false },
      { text: "Data Fim férias", value: "data_fin", sortable: false },
      { text: "Dias de Gozo", value: "dias_gozados", sortable: false },
      { text: "Dias Abono", value: "abono", sortable: false },
      { text: "Dias Cassados", value: "dias_cassados", sortable: false },
      { text: "Data Inicio Cassação", value: "data_inicio_cassacao", sortable: false },
      { text: "Data fim Cassação", value: "data_fim_cassacao", sortable: false },
      { text: "Dias para vantagem", value: "dias_vantagem", sortable: false },
    ],

    items: [],
    page: 1,
    pageCount: 0,

    selected: [],
    selectedAction: {},
    singleSelect: false,
    idSelected: null,

    filter: {},

    optionsFilter: {
    },
    ferias:[],

    loading: {
      table: false,
      btn: false,
      field: false,
    }
  }),

  beforeMount() {
    this.initializeFilter()
    this.ferias = this.$route.params.ferias 
  },

  mounted() {
   this.getHistoricoAnual();
  },

  filters: {
    
  },

  watch: {
  },

  methods: {

    initializeFilter() {
      this.filter = {
        dataInicio: null,
        dataFim: null,
        status:null,
        dataCassacaoInicio:null,
        dataCassacaoFim:null,
        diasCassados:null,
        diasAbono:null,
        diasVantagem:null,
        diasGozo:null,
        anoReferencia:null


      }
    },

    trocarHistoricoFerias(name){
      this.$router.push({ name: name, params:{ferias: this.$route.params.ferias} })
    },

    prepareFormFilter() {
      const filter = new FormData();

      filter.append("page", this.page);
      this.filter.anoReferencia ? filter.append("ano_referencia", this.filter.anoReferencia) : null;
      this.filter.status ? filter.append("status", this.filter.status): null;
      this.filter.dataInicio ? filter.append("data_ini", moment(this.filter.dataInicio).format("YYYY-MM-DD")) : null;
      this.filter.dataFim ? filter.append("data_fin", moment(this.filter.dataFim).format("YYYY-MM-DD")) : null;

      this.filter.dataCassacaoInicio ? filter.append("data_inicio_cassacao", moment(this.filter.dataCassacaoInicio).format("YYYY-MM-DD")) : null;
      this.filter.dataCassacaoFim ? filter.append("data_fim_cassacao", moment(this.filter.dataCassacaoFim).format("YYYY-MM-DD")) : null;
      this.filter.diasCassados ? filter.append("dias_cassados", this.filter.diasCassados) : null;
      this.filter.diasAbono ? filter.append("abono", this.filter.diasAbono) : null;
      this.filter.diasVantagem ? filter.append("dias_vantagem", this.filter.diasVantagem) : null;
      this.filter.diasGozo ? filter.append("dias_gozados", this.filter.diasGozo) : null;

      return filter;
    },

    async getHistoricoAnual() {
      console.log();
      this.loading.table = true;
      const filter = this.prepareFormFilter();
      const response = await HistoricoFeriasService.feriasAnuais(filter, this.$route.params.ferias.idSigrh);
      console.log(response)
      this.items = response.data;
      this.pageCount = response.last_page;
      this.totalItems = response.total;
      this.loading.table = false;
    },
  }
};